var exports = {
  "H": "sidebarToggleButton__W2d-NN",
  "L": "slimLineTopTabs__FFUox_",
};

module.exports = exports;
